import { render, staticRenderFns } from "./AlertHandlerList.vue?vue&type=template&id=1f945c3f"
import script from "./AlertHandlerList.vue?vue&type=script&lang=js"
export * from "./AlertHandlerList.vue?vue&type=script&lang=js"
import style0 from "./AlertHandlerList.vue?vue&type=style&index=0&id=1f945c3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports